<template>
  <dl class="myo_search_list">
    <dt>{{ i18n.myoffice.Country }}</dt>
    <dd>
        <vSelect :options="countries" :reduce="value => value.id" :modelValue="select_bz_cd" @update:modelValue="set_bz_cd" :clearable="false" class="custom-vselect" />
    </dd>
  </dl>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "countryForm",
    components : {
      vSelect
    },
    props:{
      parent_bz_cd  : {
        type    : String,
        default : ''
      },
    },
    data: () => ({
      i18n: window.i18n,
      select_bz_cd : "",
      countries : [ { "id": '', "label": 'ALL' }, { "id": 'USA', "label": 'USA' }, { "id": 'CAN', "label": 'CANADA' } ]
    }),
    watch : {
        bz_cd(bz_cd){
            this.set_bz_cd(bz_cd);
        }
    },
    mounted() {
      this.select_bz_cd = this.parent_bz_cd;
    },
    methods : {
        set_bz_cd(bz_cd){
            this.select_bz_cd = bz_cd;
            this.$emit("set_bz_cd", bz_cd);
        }
    }
}
</script>

<style scoped>
.custom-vselect {
    z-index: 1 !important;
}
</style>
